import { motion } from "framer-motion";
import { variantContainer, variant02 } from "../motion/variants";
import { useHistory } from "react-router-dom";
import { useGlobalStateContext } from "../context/globalContext";
import { useEffect } from "react";

const Header = ({ onCursor }) => {
  const { hiddenNav } = useGlobalStateContext();
  const history = useHistory();

  return (
    <motion.header
      id="header"
      variants={variantContainer(0.5, hiddenNav)}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="logo"
        variants={variant02}
        onMouseEnter={() => onCursor("hovered")}
        onMouseLeave={onCursor}
        onClick={() => history.push("/")}
      >
        <span>NASA</span>
      </motion.div>
      <motion.div
        onClick={() => {
          if (history.location.pathname === `/credits`) {
            history.push("/");
          } else {
            history.push("/credits");
          }
        }}
        variants={variant02}
        onMouseEnter={() => onCursor("hovered")}
        onMouseLeave={onCursor}
        className={`menu ${
          history.location.pathname === `/credits` ? "closed" : ""
        }`}
      >
        <span></span>
        <span></span>
      </motion.div>
    </motion.header>
  );
};

export default Header;
